export default __webpack_public_path__ + "static/media/ShareToCommunity.feddcce8.png";